import * as React from "react";
import { styled } from "@mui/material/styles";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 20,
  height: 20,
  border: "1px solid rgba(0, 0, 0, 0.65)",
  backgroundColor: "#fff",
}));

const BpCheckedIcon = styled("span")(({ theme }) => ({
  borderRadius: "50%",
  width: 20,
  height: 20,
  border: "5px solid #3535f3", // blue ring
  backgroundColor: "#fff", // white inside
}));

// Inspired by blueprintjs
function BpRadio(props) {
  return (
    <Radio
      sx={{
        padding: "5px",
        "&:hover": {
          bgcolor: "transparent",
        },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
    />
  );
}

export default function CustomizedRadios({
  handleChange,
  options,
  label,
  optionGap = 5,
  ...rest
}) {
  return (
    <FormControl>
      {label && <FormLabel id="demo-customized-radios">{label}</FormLabel>}
      <RadioGroup
        name="customized-radios"
        {...rest}
        onChange={(e) => {
          let val = e.target.value;
          if (e.target.value === "true") {
            val = true;
          }
          if (e.target.value === "false") {
            val = false;
          }
          handleChange(val);
        }}>
        {options.map((ele, i) => {
          return (
            <FormControlLabel
              key={i}
              value={ele.value}
              control={<BpRadio />}
              label={ele.label}
              disabled={ele.disabled || false}
              className="radioLabelText"
              sx={{
                marginRight: `${optionGap}px`,  // 👈 spacing from UI
                ".MuiFormControlLabel-label": {
                  fontSize: "13px",
                },
              }}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
